import { useEffect, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import { convertToGregorian } from "../utils/date";

const useDateChange = (initialStartDate, initialEndDate, range) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [defaultValueDate, setDefaultValueDate] = useState();

    //handle converting the date format to the Gregorian
    const handleDateFormatChange = (rangeDate, isPersianCalendar) => {
        if (rangeDate) {
            const [start, end] = rangeDate;
            if (range) {
                if (!isPersianCalendar) {
                    setStartDate(start?.format("YYYY-MM-DD"));
                    setEndDate(end?.format("YYYY-MM-DD"));
                } else {
                    const convertedStartDate = convertToGregorian(start);
                    setStartDate(convertedStartDate?.toISOString().split("T")[0]);
                    if (!!end) {
                        const convertedEndDate = convertToGregorian(end);
                        setEndDate(convertedEndDate?.toISOString().split("T")[0]);
                    } else {
                        setEndDate(null);
                    }
                }
            } else {
                const convertedStartDate = convertToGregorian(start);
                setStartDate(isPersianCalendar ? convertedStartDate?.toISOString().split("T")[0] : start?.format("YYYY-MM-DD"));
            }
        } else {
            setStartDate(null);
            setEndDate(null);
            setDefaultValueDate(null);
        }
    };

    //default value for dates
    useEffect(() => {
        if (initialStartDate || initialEndDate) {
            setStartDate(initialStartDate);
            setEndDate(initialEndDate || initialStartDate);
            const originalDatePickerValue = [
                new DateObject(new Date(initialStartDate)),
                new DateObject(new Date(initialEndDate || initialStartDate)),
            ];

            setDefaultValueDate(originalDatePickerValue);
        }
    }, [range, initialStartDate, initialEndDate]);

    return { startDate, endDate, defaultValueDate, handleDateFormatChange };
};

export default useDateChange;
